import { loanApplicationService as borrowerLoanOriginationService } from "@/modules/client/loan-application/store/services/loan-application-service";
// Trigger endpoint injection
import "@/modules/client/loan-application/store/services/endpoints";
import { dealCapitalStackLayerService } from "@/features/CapitalStack/store/services";
import { lenderService } from "@/modules/contacts/features/lender/store/services/lender-service";
import "@/modules/contacts/features/lender/store/services/endpoints";
import { borrowerService } from "@/modules/contacts/features/borrower/store/services/borrower-service";
import "@/modules/contacts/features/borrower/store/services/endpoints";
import { referrerService } from "@/modules/contacts/features/referrer/store/services/referrer-service";
import "@/modules/contacts/features/referrer/store/services/endpoints";
import { contactService as contactServiceV2 } from "@/modules/contacts/store/services/contact-service";
import "@/modules/contacts/store/services/endpoints";
import { lendingProgramService } from "@/features/LendingProgram/services/lendingProgramService";
import { capworksProgramService } from "@/modules/capworks/store/services/capworks-program-service";
import "@/modules/capworks/store/services/endpoints";
import { lenderHubProfileService } from "@/features/LenderHub/Profile/services/profileService";
import { resourceShareService } from "@/features/LenderHub/ResourceShare/services/resourceShareService";
import { lenderResourceShareService } from "@/modules/contacts/features/lender/store/resource-share-services/lender-resource-share-service";
import "@/modules/contacts/features/lender/store/resource-share-services/endpoints";
import { lenderBoardService } from "@/features/LenderBoard/Management/store/lenderBoardService";
import { loanSummaryService } from "@/features/LoanSummary/Management/store/services/loanSummaryService";
import { lenderOfferService } from "@/features/LenderBoard/Offer/store/services/lenderOfferService";
import { lenderBoardChatService } from "@/features/LenderBoard/Chat/store/services/lenderBoardChatService";
import { lenderHubChatService } from "@/features/LenderHub/Chat/store/services/lenderHubChatService";
import { lenderHubDealService } from "@/features/LenderHub/Deal/store/services/lenderHubDealService";
import { lenderHubOfferService } from "@/features/LenderHub/Offer/store/services/lenderHubOfferService";
import { lenderHubLoanSummaryService } from "@/features/LenderHub/LoanSummary/store/services/lenderHubLoanSummaryService";
import { accountService } from "@/modules/account/store/services/account-service";
import { sharedService } from "@/modules/shared/store/services/shared-service";
import "@/modules/shared/store/services/endpoints";
import { connexService } from "@/modules/contacts/features/lender/features/out-of-network/store/connex-service";
import { capworksSignupService } from "@/modules/capworks/features/signup/store/services/capworks-signup-service";
import "@/modules/capworks/features/signup/store/services/endpoints";
import { loanService } from "@/modules/loan/store/services/loan-service";
import "@/modules/loan/store/services/endpoints";
import { dashboardService } from "./dashboardService";
import { documentService } from "./documentService";
import { needsListTemplateService } from "./needsListTemplateService";
import { needsListTemplateDocumentService } from "./needsListTemplateDocumentService";
import { employeeService } from "./employeeService";
import { notificationService } from "./notificationService";
import { loanEmployeeService } from "./loanEmployeeService";
import { loanBorrowerService } from "./loanBorrowerService";
import { loanReferrerService } from "./loanReferrerService";
import { borrowerNeedsListService } from "./borrowerNeedsListService";
import { borrowerNeedsListFileService } from "./borrowerNeedsListFilesService";
import { fileProcessorService } from "./fileProcessorService";
import { borrowerDashboardService } from "./borrowerDashboard";
import { loanNoteService } from "./loanNoteService";
import { chunkedUploadService } from "./chunkedUploadService";

export const serviceReducers = {
  [dashboardService.reducerPath]: dashboardService.reducer,
  [documentService.reducerPath]: documentService.reducer,
  [needsListTemplateService.reducerPath]: needsListTemplateService.reducer,
  [needsListTemplateDocumentService.reducerPath]: needsListTemplateDocumentService.reducer,
  [employeeService.reducerPath]: employeeService.reducer,
  [notificationService.reducerPath]: notificationService.reducer,
  [loanService.reducerPath]: loanService.reducer,
  [loanEmployeeService.reducerPath]: loanEmployeeService.reducer,
  [loanBorrowerService.reducerPath]: loanBorrowerService.reducer,
  [loanReferrerService.reducerPath]: loanReferrerService.reducer,
  [borrowerNeedsListService.reducerPath]: borrowerNeedsListService.reducer,
  [borrowerNeedsListFileService.reducerPath]: borrowerNeedsListFileService.reducer,
  [fileProcessorService.reducerPath]: fileProcessorService.reducer,
  [loanSummaryService.reducerPath]: loanSummaryService.reducer,
  [borrowerDashboardService.reducerPath]: borrowerDashboardService.reducer,
  [loanNoteService.reducerPath]: loanNoteService.reducer,
  [accountService.reducerPath]: accountService.reducer,
  [lenderOfferService.reducerPath]: lenderOfferService.reducer,
  [borrowerLoanOriginationService.reducerPath]: borrowerLoanOriginationService.reducer,
  [dealCapitalStackLayerService.reducerPath]: dealCapitalStackLayerService.reducer,
  [contactServiceV2.reducerPath]: contactServiceV2.reducer,
  [lenderService.reducerPath]: lenderService.reducer,
  [borrowerService.reducerPath]: borrowerService.reducer,
  [referrerService.reducerPath]: referrerService.reducer,
  [lendingProgramService.reducerPath]: lendingProgramService.reducer,
  [capworksProgramService.reducerPath]: capworksProgramService.reducer,
  [lenderHubProfileService.reducerPath]: lenderHubProfileService.reducer,
  [resourceShareService.reducerPath]: resourceShareService.reducer,
  [lenderResourceShareService.reducerPath]: lenderResourceShareService.reducer,
  [lenderBoardService.reducerPath]: lenderBoardService.reducer,
  [lenderBoardChatService.reducerPath]: lenderBoardChatService.reducer,
  [lenderHubDealService.reducerPath]: lenderHubDealService.reducer,
  [lenderHubOfferService.reducerPath]: lenderHubOfferService.reducer,
  [lenderHubChatService.reducerPath]: lenderHubChatService.reducer,
  [lenderHubLoanSummaryService.reducerPath]: lenderHubLoanSummaryService.reducer,
  [chunkedUploadService.reducerPath]: chunkedUploadService.reducer,
  [connexService.reducerPath]: connexService.reducer,
  [sharedService.reducerPath]: sharedService.reducer,
  [capworksSignupService.reducerPath]: capworksSignupService.reducer,
};

export const serviceMiddleware = [
  dashboardService.middleware,
  documentService.middleware,
  needsListTemplateService.middleware,
  needsListTemplateDocumentService.middleware,
  employeeService.middleware,
  notificationService.middleware,
  loanService.middleware,
  loanEmployeeService.middleware,
  loanBorrowerService.middleware,
  loanReferrerService.middleware,
  borrowerNeedsListService.middleware,
  borrowerNeedsListFileService.middleware,
  fileProcessorService.middleware,
  loanSummaryService.middleware,
  borrowerDashboardService.middleware,
  loanNoteService.middleware,
  accountService.middleware,
  lenderOfferService.middleware,
  borrowerLoanOriginationService.middleware,
  dealCapitalStackLayerService.middleware,
  contactServiceV2.middleware,
  lenderService.middleware,
  borrowerService.middleware,
  referrerService.middleware,
  lendingProgramService.middleware,
  capworksProgramService.middleware,
  lenderHubProfileService.middleware,
  resourceShareService.middleware,
  lenderResourceShareService.middleware,
  lenderBoardService.middleware,
  lenderBoardChatService.middleware,
  lenderHubDealService.middleware,
  lenderHubOfferService.middleware,
  lenderHubChatService.middleware,
  lenderHubLoanSummaryService.middleware,
  chunkedUploadService.middleware,
  connexService.middleware,
  sharedService.middleware,
  capworksSignupService.middleware,
];
